import React, { Component } from "react";
import SearchUser from "./searchUser";
import SearchedProfile from "./searchedProfile";

export default class inAppProfile extends Component<{ match: any }> {
  render() {
    return <SearchedProfile match={this.props.match} inApp={true} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/screens/inAppProfile.tsx